import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { IconSetService } from '@coreui/icons-angular';
import { TenantManagementStubService, FrameworkService, AppShellComponent, AppFrameworkContextService, EntityBottomOffCanvasOutletComponent } from '@optima-stride-ai/optima-app-framework';
import { closeAllOffCanvas, iconSubset, OffCanvasPlacement, OptimaOffCanvasService, ToastContainerComponent } from '@optima-stride-ai/optima-components';
import { benzaitenTenants } from '../../assets/tenants';
import { DefaultModalComponent } from "../modal/modal-component/modal.component";
import { Subject, takeUntil } from 'rxjs';
import { OffCanvasCollectiveComponent } from "../off-canvas/off-canvas-form/off-canvas-collective/off-canvas-collective.component";
import { IBizEntity } from '@optima-stride-ai/core';
import { redirectToRespectiveExplorer } from '../context-menu/context-menu';
import { ContextMenuService } from '../context-menu/context-menu';
import { Router } from '@angular/router';
import { AppStateService } from '../state/app-state';
import { OffcanvasService } from '@coreui/angular';
import { LinkNavigationService } from '../link-navigation/link-navigation.service';

@Component({
  selector: 'app-app-shell',
  imports: [AppShellComponent, ToastContainerComponent, DefaultModalComponent, OffCanvasCollectiveComponent, EntityBottomOffCanvasOutletComponent],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.sass',
})
export class ApplicationShellComponent implements OnInit, OnDestroy {
  protected readonly title = signal('benzaiten');
  private destroy$ = new Subject<void>();
  private readonly tenantService: TenantManagementStubService = inject(TenantManagementStubService);
  public readonly frameworkService : FrameworkService = inject(FrameworkService);
  private appFrameworkContext = inject(AppFrameworkContextService);
  readonly router: Router = inject(Router);
  readonly appStateService: AppStateService = inject(AppStateService);
  readonly offCanvasFormService = inject(OptimaOffCanvasService);
  readonly offCanvasServiceRef = inject(OffcanvasService);
  private readonly contextMenuService = inject(ContextMenuService);
  private readonly linkNavigationService = inject(LinkNavigationService);
  // private iconSetService: IconSetService = inject(IconSetService);
  get isReady(): boolean {
    return this.frameworkService.currentApp !== null;
  }

  constructor(
    public framework: FrameworkService,
    private iconSetService: IconSetService
  ){
    // this.iconSetService.icons = { ...iconSubset };
  }
  
  ngOnInit(): void {
    this.initiazlizeTenants();
    this.subscribeToAppContext();
    this.linkNavigationService.init();
  }

  private initiazlizeTenants(): void {
    const tenants = benzaitenTenants;

    this.tenantService.setTenants(tenants);
  }

  private subscribeToAppContext(): void {
    this.appFrameworkContext.context$
    .pipe(takeUntil(this.destroy$))
    .subscribe(context => {
      if(context) {
        // console.log('App context updated:', context);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.linkNavigationService.destroy();
  }

  onQuickActionItemClicked(item: IBizEntity): void {
       redirectToRespectiveExplorer(item, this.router, this.appStateService);
      // this.onCloseButtonClicked();
      closeAllOffCanvas(this.offCanvasFormService, this.offCanvasServiceRef, OffCanvasPlacement.Bottom);
  }

  onAddQuickActionClicked(): void {
    this.contextMenuService.onAddQuickActionCategoryClicked();
  }
}
